import { FetchAuthorizedProviders } from '../../responses';

export const authorizedProviders: FetchAuthorizedProviders = [
    {
        id: 'meli',
        name: 'meli',
        available: true,
        icon: 'meli',
        completed: true,
    },
    {
        id: 'shopify',
        name: 'shopify',
        available: true,
        icon: 'shopify',
        completed: true,
    },
    {
        id: 'tiendanube',
        name: 'tiendanube',
        available: true,
        icon: 'tiendanube',
        completed: true,
    },
];
